import React from "react";
import { scratch_images_array } from "../../content_option";
import "./style.css"; // Ensure styles are imported if needed

const Scratch = ({ openModal }) => {
  return (
    <>
      <div className="po_section">
        <h2 style={{ fontWeight: "bold", fontSize: "24px" }}>
          Distortion Play SCRAAATCH
          <h5 style={{ fontWeight: "bold", fontSize: "10px" }}>Rolling Bar Prototype 3, 2024</h5>
          <h6 style={{ fontWeight: "bold", fontSize: "10px" }}>
            Sound, steel, pipe, flat expanded metal, acrylic lenticular panels, custom sound effect processors (printed circuit board, capacitors, resistors, microcontroller, regulators, DC power jack), contact microphones, guitar pickups, wireless audio transmitters, wireless audio receivers, portable batteries, various hardware and electronics; Distortion Etudes (Scene for Prototype 3) (2023-2024) which includes audio recording, PA system, camcorder, tripod, three-channel projections with video (color, silent, 23:43 minutes), camcorder footage (color, silent, time variable), and live feed of installation;
          </h6>
        </h2>

        <button className="download-button">
          <a
            href="https://companygallery.us/exhibitions/distortion-play"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more
          </a>
        </button>

        {/* First image, enlarged */}
        <div className="po_item_big" style={{ width: "100%" }}>
          <img
            src={scratch_images_array[0]}
            alt="scratch-0"
            className="full-width-img"
            onClick={() => openModal(scratch_images_array[0])}
          />
        </div>

        {/* Second image */}
        <div className="po_item_big">
          <img
            src={scratch_images_array[1]}
            alt="scratch-1"
            className="full-width-img"
            onClick={() => openModal(scratch_images_array[1])}
          />
        </div>

        {/* Third image removed (duplicate of the last image) */}

        {/* Fourth and fifth images, side by side */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          <div className="po_item" style={{ flex: 1 }}>
            <img
              src={scratch_images_array[3]}
              alt="scratch-3"
              className="responsive-image"
              onClick={() => openModal(scratch_images_array[3])}
            />
          </div>
          <div className="po_item" style={{ flex: 1 }}>
            <img
              src={scratch_images_array[4]}
              alt="scratch-4"
              className="responsive-image"
              onClick={() => openModal(scratch_images_array[4])}
            />
          </div>
        </div>

        {/* Sixth and seventh images, side by side */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          <div className="po_item" style={{ flex: 1 }}>
            <img
              src={scratch_images_array[5]}
              alt="scratch-5"
              className="responsive-image"
              onClick={() => openModal(scratch_images_array[5])}
            />
          </div>
          <div className="po_item" style={{ flex: 1 }}>
            <img
              src={scratch_images_array[6]}
              alt="scratch-6"
              className="responsive-image"
              onClick={() => openModal(scratch_images_array[6])}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Scratch;
